import { useEffect, useState } from "react";
import { FileText } from "lucide-react";

import { useAuth } from "@/context/AuthContext";
import { request } from "@/lib/api";

const displayDate = (value) => new Intl.DateTimeFormat("en-IN", { day: "numeric", month: "short", year: "numeric" }).format(new Date(value));

export default function ReportsPage() {
  const { token } = useAuth();
  const [reports, setReports] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    request("/reports", {}, token)
      .then(setReports)
      .catch(() => setReports([]))
      .finally(() => setIsLoading(false));
  }, [token]);

  return (
    <section className="page-stack" data-testid="reports-page">
      <div className="page-heading">
        <p className="eyebrow">Your health</p>
        <h1>Reports</h1>
        <p>Every report from your completed health checks, in one place.</p>
      </div>
      <section className="updates-list" data-testid="reports-list">
        {isLoading ? null : reports.length ? (
          reports.map((report) => (
            <article className="update-item" key={report.apollo_sub_order_id} data-testid={`report-${report.apollo_sub_order_id}`}>
              <FileText size={20} />
              <div>
                <strong>{report.status === "completed" ? "Report ready" : "Partial report"}</strong>
                <span>{displayDate(report.received_at)}</span>
                {report.report_urls.map((url, index) => (
                  <div key={url}>
                    <a href={url} target="_blank" rel="noreferrer" data-testid={`report-link-${report.apollo_sub_order_id}-${index}`}>
                      View report {report.report_urls.length > 1 ? index + 1 : ""}
                    </a>
                  </div>
                ))}
              </div>
              <small>{report.status.replaceAll("_", " ")}</small>
            </article>
          ))
        ) : (
          <div className="empty-updates" data-testid="empty-reports">
            <FileText size={28} />
            <p>Your health check reports will appear here once they're ready.</p>
          </div>
        )}
      </section>
    </section>
  );
}
